import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFaceId = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M4.158 8.726V6.095a2.337 2.337 0 0 1 2.337-2.337h2.631a.779.779 0 1 0 0-1.558H6.495A3.895 3.895 0 0 0 2.6 6.095v2.631a.779.779 0 1 0 1.558 0ZM14.874 2.2a.779.779 0 0 0 0 1.558h2.631a2.337 2.337 0 0 1 2.337 2.337v2.631a.779.779 0 0 0 1.558 0V6.095A3.895 3.895 0 0 0 17.505 2.2h-2.631ZM19.842 18.062v-2.63a.779.779 0 1 1 1.558 0v2.63a3.895 3.895 0 0 1-3.895 3.895h-2.631a.779.779 0 0 1 0-1.558h2.63a2.337 2.337 0 0 0 2.338-2.337ZM9.126 21.957a.779.779 0 0 0 0-1.558H6.495a2.337 2.337 0 0 1-2.337-2.337v-2.63a.779.779 0 0 0-1.558 0v2.63a3.895 3.895 0 0 0 3.895 3.895h2.631Z"
    />
    <path
      fill="#F7A600"
      d="M9.092 8.016c.43 0 .779.35.779.78v1.557a.779.779 0 0 1-1.558 0V8.795c0-.43.349-.779.779-.779ZM15.323 8.016c.43 0 .78.35.78.78v1.557a.779.779 0 0 1-1.559 0V8.795c0-.43.349-.779.78-.779ZM12.208 8.016c.43 0 .78.35.78.78v3.894c0 .99-.803 1.792-1.792 1.792a.779.779 0 0 1 0-1.558c.129 0 .233-.105.233-.234V8.795c0-.43.35-.779.78-.779ZM8.5 15.377a.779.779 0 0 1 1.099-.085 3.41 3.41 0 0 0 4.438 0 .779.779 0 1 1 1.014 1.183 4.968 4.968 0 0 1-6.466 0 .779.779 0 0 1-.085-1.098Z"
    />
  </svg>
);
export default SvgTwoColorFaceId;
